import React, { useEffect, useState, } from 'react';
import { Link, useLocation } from "react-router-dom";
import { MenuUnfoldOutlined, MenuFoldOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { Menu } from 'antd';
import './Menu.scss'
import { useSelector } from 'react-redux';
import { ICON_MENU } from '../../env';
import { selectorMenu } from '../../store/slices/menuSlice';
import { selectorGroupCustumer } from '../../store/slices/groupCustumerSlice';
import { selectorPermission } from '../../store/slices/permissionSlice';
import { selectorCategoryCar } from '../../store/slices/categoryCarSlice';

type MenuItem = Required<MenuProps>['items'][number];

function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[],
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
  } as MenuItem;
}

const WidgetMenu: React.FC = () => {
  const menuSlice = useSelector(selectorMenu)
  const categoryCar = useSelector(selectorCategoryCar)
  const listCategoryCarName = categoryCar.map((item: any) => item.categoryCarName)
  localStorage.setItem('vehicle_brand', listCategoryCarName.join(','))
  const groupCustumerSlice = useSelector(selectorGroupCustumer)

  const permissionSlice = useSelector(selectorPermission)
  const items: MenuProps['items'] = menuSlice?.filter((menuItem) => permissionSlice.some((p) => p.menuId === menuItem.id && p.access))
    .map((menuItem) => (
      getItem(menuItem.name, menuItem.menuUrl.slice(1), <img src={ICON_MENU + menuItem.icon} alt="" />,
        menuItem.childrenMenu && menuItem.childrenMenu.filter((children) => permissionSlice.some((p) => p.menuId === children.id && p.access)).map((children) => (
          getItem(
            <Link
              to={
                children.menuUrl === 'null' || children.menuUrl === null ? '/' : children.menuUrl
              }
              state={
                {
                  isMenu: true
                }
              }
              rel="noopener noreferrer"
            >
              {children.name}
            </Link>,
            `${children.menuUrl === 'null' || children.menuUrl === null ? '/' : children.menuUrl}`,
            undefined,
            children.id === 9 ? groupCustumerSlice.slice(0, 5).map((itemGroup) => (
              getItem(
                <Link className='fixed-width-submenu' to={`${children.menuUrl}?idgroupcustomer=${itemGroup.id}`} rel="noopener noreferrer">
                  {/* {`(${itemGroup.customerCount}) ${itemGroup.title}`} */}
                  {itemGroup.title}
                </Link>,
                `${children.menuUrl}?idgroupcustomer=${itemGroup.id}`,
                undefined,
              )
            )) : undefined
          )
        ))
      )
    ))
  const pathConvert = (path: string) => {
    const pathArr = path.split('/')
    let result = ''

    if (pathArr.length > 3) {
      result = [pathArr[0], pathArr[1], pathArr[2]].join('/')
    } else {
      result = path
    }

    return result
  }

  let location = useLocation()
  const [current, setCurrent] = useState(
    location.search.includes('idgroupcustomer') ? `${location.pathname}${location.search}` : location.pathname === '/analysis-report/vip-customer-care' || location.pathname === ''
      ? '/analysis-report/vip-customer-care'
      : pathConvert(location.pathname)
  )

  const parents = ['analysis-report', 'customer', 'member-card', 'vehicle-management', 'marketing', 'departmental-unit', 'system-configuration']
  const [currentParent, setCurrentParent] = useState(
    location.search.includes('idgroupcustomer') ? ['customer', '/customer/group'] : [parents.find(item => current.includes(item)) || 'analysis-report']
  )

  useEffect(() => {
    if (location) {
      if (current !== location.pathname) {
        setCurrent(location.pathname)
      }
      const parents = ['analysis-report', 'customer', 'member-card', 'vehicle-management', 'marketing', 'departmental-unit', 'system-configuration']
      const parentName = parents.find(item => current.includes(item)) || ''
      setCurrentParent([parentName])
    }
  }, [location, current])

  const onClick: MenuProps['onClick'] = (e) => {
    setCurrent(e.key)
  };

  const [collapsed, setCollapsed] = useState(false);
  const toggleCollapsed = () => {
    const appElem = document.getElementsByClassName('app')[0]
    if (!appElem) return false
    appElem.classList.toggle('menu-collapsed')
    setCollapsed(!collapsed);
  };

  return (
    <div className='app-menu-vertical'>
      <Menu
        onClick={onClick}
        defaultSelectedKeys={[current]}
        defaultOpenKeys={currentParent}
        mode="inline"
        items={items}
        inlineCollapsed={collapsed}
        className='rs-scrollbar'
      />
      <div
        className='menu-trigger'
        onClick={toggleCollapsed}
      >
        {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
      </div>
    </div>
  );
};

export default WidgetMenu;
